export default __webpack_public_path__ + "static/media/dots-24dp.c3d21816.svg";